import { connect } from 'react-redux';
import BuyVolumes from '../../components/buyActivity/BuyVolumes';
import { getBuyVolumes } from '../../actions/actions_buy_activity';
import {fetchFormFields} from "../../actions/actions_form_fields";
import {fetchUnitsOfMeasure} from "../../actions/actions_units_of_measure";

const mapStateToProps = state => {
  return {
    requesting: state.buyActivity.requestingBuyVolumes,
    error: state.buyActivity.buyVolumesError,
    buyVolumes: state.buyActivity.buyVolumes,
    currencies: state.form_fields.currency,
    unitsOfMeasure: state.units_of_measure,
    token: state.user.token,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getBuyVolumes: config => dispatch(getBuyVolumes(config)),
    getCurrencies: token => dispatch(fetchFormFields(token, '?type=currency')),
    getUnitsOfMeasure: token => dispatch(fetchUnitsOfMeasure(token))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BuyVolumes);
